import { FeatureToggle, UserPreferences } from '..';

export default {
  FETCH_DATA: 'FETCH_DATA',
  FETCH_SCHEME: 'FETCH_SCHEME',
  FETCH_DATA_SENDING: 'FETCH_DATA_SENDING',
  FETCH_OFFLINE_DATA: 'FETCH_OFFLINE_DATA',
  GLOBAL_ERROR: 'GLOBAL_ERROR',
  GLOBAL_REQUEST: 'GLOBAL_REQUEST',
  GLOBAL_STATE_UPDATE: 'GLOBAL_STATE_UPDATE',
  GLOBAL_STATE_UPDATE_NAVIGATION: 'GLOBAL_STATE_UPDATE_NAVIGATION',
  GLOBAL_STACK_INFO: 'GLOBAL_STACK_INFO',
  USER_STATE_UPDATE: 'USER_STATE_UPDATE',
  OFFLINE_MODE: 'OFFLINE_MODE',
  SET_TOTAL_FAILURE: 'SET_TOTAL_FAILURE',
  UNSET_TOTAL_FAILURE: 'UNSET_TOTAL_FAILURE',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  FETCH_PREFERENCES: 'FETCH_PREFERENCES',
  FETCH_PREFERENCES_ERROR: 'FETCH_PREFERENCES_ERROR',
  SET_PREFERENCES: 'SET_PREFERENCES',
  SET_PREFERENCES_ERROR: 'SET_PREFERENCES_ERROR',
  DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
  DISMISS_ALL_NOTIFICATIONS: 'DISMISS_ALL_NOTIFICATIONS',
  SET_AWAITING_RESPONSE: 'SET_AWAITING_RESPONSE',
  FETCH_SCHEME_CONTROLS_SENDING: 'FETCH_SCHEME_CONTROLS_SENDING',
  FETCH_SCHEME_CONTROLS: 'FETCH_SCHEME_CONTROLS',
  FUND_CODE: 'FUND_CODE',
  FETCH_FEATURE_FLAGS: 'FETCH_FEATURE_FLAGS',
  RESET_GLOBAL_STATE: 'RESET_GLOBAL_STATE',
  TOGGLE_TIMEOUT_POPUP: 'TOGGLE_TIMEOUT_POPUP',
  LAUNCH_DARKLY: 'LAUNCH_DARKLY',
};

export const apiConstants = {
  FETCH_NAVIGATION_API_URL: '/api/system/navigation',
  FETCH_SCHEME_DATA_URL: '/api/system/scheme',
  FETCH_PREFERENCES_API_URL: '/api/preferences/get-preferences',
  SAVE_PREFERENCES_API_URL: '/api/preferences/save-preferences',
  FETCH_CONTEXT_ENTITLEMENTS_API_URL: '/api/system/context-entitlements',
  FETCH_SCHEME_CONTROLS_URL: '/api/system/controls',
  FETCH_CONTENT: '/api/content',
  FETCH_FEATURE_FLAGS_API_URL: '/api/feature-toggle/flag-values',
  // Content JSON files
  DEFAULT_CONTENT_API: '/content/en.json',
};

export const journeyIds = {
  ANNUAL_ACCOUNT_STATEMENTS: 'aas',
  EXPRESSION_OF_WISH: 'eow',
  FORMS_AND_DOCUMENTS: 'fad',
  TRANSFERS_IN: 'tvin',
  MASTER_TRUST: 'rmt',
  LIFESTYLE_STRATEGY: 'ls',
  CHANGE_INVESTMENTS: 'ci',
  MY_INVESTMENTS: 'mi',
  COMMUNICATION_PREFERENCES: 'cp',
  MY_DOCUMENTS: 'md',
  EDIT_CONTACT_DETAILS: 'ecd',
};

export const stackPlaceholder = '#STACK_PLACEHOLDER#';

export const routes = {
  HOME: `https://www.planviewer.fidelity.co.uk/planviewer/ria/DisplayNavHome.action?Tab=207${stackPlaceholder}`,
  UPDATE_BENEFICIARIES_LANDING: '/eow/update-beneficiaries',
  UPDATE_BENEFICIARIES: '/eow/update-beneficiaries/edit',
  ANNUAL_ACCOUNT_STATEMENTS: '/aas/annual-account-statements',
  EXAMPLE_FORM: '/exampleform',
  FORMS_AND_DOCUMENTS: '/fd/forms-documents',
  TRANSFERS_IN: '/tvin/transfers-in',
  TRANSFERS_DETAILS: '/tvin/details',
  TRANSFERS_REVIEW: '/tvin/review',
  TRANSFERS_CONFIRMATION: '/tvin/confirmation',
  MASTER_TRUST: '/rmt/master-trust',
  MASTER_TRUST_CHOOSE_INVESTMENTS: '/rmt/choose-investments',
  MASTER_TRUST_CONFIRMATION: '/rmt/confirmation',
  MASTER_TRUST_REVIEW: '/rmt/review',
  LIFESTYLE_STRATEGY: '/ls/lifestyle-strategy',
  CHANGE_INVESTMENTS: '/ci/change-investments',
  VIEW_CURRENT_INVESTMENTS: '/ci/view-current-investments',
  CHANGE_CURRENT_INVESTMENT: '/ci/change-current-investments',
  VIEW_FUTURE_INVESTMENTS: '/ci/view-future-investments',
  CHANGE_FUTURE_INVESTMENTS: '/ci/change-future-investments',
  CI_REVIEW: '/ci/review',
  INVESTMENTS_HOME_PAGE: '',
  CONTRIBUTION_TYPE_SELECTION_PAGE: '/ci/contribution-type-selection',
  CI_CONFIRMATION: '/ci/confirmation',
  MY_INVESTMENTS: '/mi/my-investments',
  MY_INVESTEMENTS_FUND_MESSAGE: '/mi/fund-message',
  COMMUNICATION_PREFERENCES: '/cp/communication-preferences',
  MY_DOCUMENTS: '/md/my-documents',
  EDIT_CONTACT_DETAILS: '/ecd/editContactDetails',
  EDIT_CONTACT_DETAILS_VERIFY: '/ecd/verify',
};

export const defaultTitle = `Fidelity's Planviewer`;

export const routeTitles: Record<string, string> = {
  [journeyIds.CHANGE_INVESTMENTS]: `${defaultTitle} | Change investments`,
  [journeyIds.MY_INVESTMENTS]: `${defaultTitle} | My investments`,
  [journeyIds.MASTER_TRUST]: `${defaultTitle} | Retirement Master Trust`,
  [journeyIds.EXPRESSION_OF_WISH]: `${defaultTitle} | Update Benificiaries`,
};

export const investmentsContextRoutes = [
  routes.MY_INVESTMENTS,
  routes.MY_INVESTEMENTS_FUND_MESSAGE,
  routes.CHANGE_INVESTMENTS,
  routes.CONTRIBUTION_TYPE_SELECTION_PAGE,
  routes.VIEW_CURRENT_INVESTMENTS,
  routes.CHANGE_CURRENT_INVESTMENT,
  routes.VIEW_FUTURE_INVESTMENTS,
  routes.CHANGE_FUTURE_INVESTMENTS,
  routes.CI_REVIEW,
  routes.CI_CONFIRMATION,
];

export const errorCodes = {
  A401: 'Sorry, there was a server error. Please try again',
  A403: 'Sorry, there is a problem with your login information',
  A500: 'Sorry, there was a server error. Please try again',
  C404: 'Error loading scheme data',
  TotalFailure: 'Something has gone wrong! The information could not be loaded.',
};

export const defaultFeatureToggleValues: FeatureToggle = {
  isPhase4Enabled: false,
  sampleFeature: false,
  AllContributionTypesButtonVariation: false,
  isTDFEnabled: false,
};

export const defaultPreferences: UserPreferences = {
  ci: {
    shouldShowCINavigationPopupAgain: true,
  },
  global: {},
};

export const LOADING = 'Loading..';
